import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import avo from 'analytics/avo';
import JBImage from 'components/essentials/JBImage';
import arQuicklookIcon from 'assets/icons/ar-quicklook.svg';

const PDPView3DButtonUI = ({ url }) => {
  const PDPView3DButtonUIRef = useRef(null);
  const linkText = `View in 3D`;

  if (!url) {
    return null;
  }

  return (
    <div
      className="relative items-center bg-white border border-solid border-gray-light7 rounded-[40px] text-white flex justify-center h-10 w-10 hover:cursor-pointer"
      data-tip="PDPView3DButtonUI__ARtip"
      data-for="PDPView3DButtonUITooltipId"
      ref={PDPView3DButtonUIRef}
    >
      <a
        id="PDPView3DButtonUI-link"
        className="h-[22px]"
        href={url}
        onClick={() => {
          avo.ctaClicked({
            text: linkText,
            targetUrl: url,
            /* eslint no-underscore-dangle: 0 */
            cta: avo.Cta._3D_VIEWER,
            location: avo.Location.PDP,
            component: avo.Component.PRODUCT_CARD,
          });
        }}
      >
        <JBImage src={arQuicklookIcon} width={22} height={22} />
      </a>
    </div>
  );
};

PDPView3DButtonUI.propTypes = {
  url: PropTypes.string,
};

export default PDPView3DButtonUI;
